import { useEffect } from 'react';
import { getParamsFromURL } from '@alfa-bank/site-helpers-common/url/get-params-from-url';
import { Cookies } from 'react-cookie';

import type { TQueryCookieMapper } from './models';
import { processOptions } from './helpers';

export function QueryCookieMapper(props: TQueryCookieMapper) {
    useEffect(() => {
        const { mappings = [] } = props;

        const cookies = new Cookies();

        const queries = getParamsFromURL({
            url: window.location.href,
        });

        mappings.forEach(mapping => {
            const { cookie, queryName } = mapping;
            const queryValue = queries[queryName];

            if (queryValue) {
                const { cookieName, ...options } = cookie;

                cookies.set(cookieName, queryValue, processOptions(options));
            }
        });
    }, []);

    return null;
}
